import Masonry from "react-masonry-css";
import {useEffect, useState} from "react";
import FunctionsData from "../../Functions/FunctionsData";
import moment from "moment";
import VetCampaignsInAreaData from "../VetCampaignsInAreaData";

/*
* This component is used to display the campaigns in the vet dashboard.
* It is used in the VetDashboard.js component.
* It is used in the VetCampaigns.js component.
* It is used in the VetCampaignsInArea.js component.
* It is used in the VetCampaignsInAreaData.js component.
* @param vet_id - The vet id.
 */
export default function VetCampaignsInArea({vet_id, optoutPublic, optoutCommunity }) {
	const [loading,setLoading] = useState(true);
	const [data,setData] = useState([]);
	useEffect(() => {
		FunctionsData.fetchDataGet(
			FunctionsData.getApiUrl('/api/campaign/area/')+vet_id,
			setData,
			loading,
			setLoading
		)
	},[loading,vet_id]);

	return (
		<div style={{width:'100%', display:'flex', gap:20}}>
			
				<div style={{ flexGrow: 1, flexBasis: '50%' }}>
					<h3>Snip'n'Chip campaigns</h3>
					<VetCampaignsInAreaData
						vet_id={vet_id}
						data={data.filter(({ campaign_target, status }) => campaign_target === 'public' && status === 'active')}
						loading={loading}
						setLoading={setLoading}
						title={"Active campaigns"}
						active
						optOut={optoutPublic}
					/>
					<VetCampaignsInAreaData
						vet_id={vet_id}
						data={data.filter(({ campaign_target, status }) => campaign_target === 'public' && status === 'upcoming')}
						loading={loading}
						setLoading={setLoading}
						title={"Upcoming campaigns"}
						upcoming
						optOut={optoutPublic}
					/>
					<VetCampaignsInAreaData
						vet_id={vet_id}
						data={data.filter(({ campaign_target, status }) => campaign_target === 'public' && status === 'past')}
						loading={loading}
						setLoading={setLoading}
						title={"Past campaigns"}
						past
						optOut={optoutPublic}
					/>
				</div>		

			{/* Conditionally render Community campaigns */}
			
				<div style={{ flexGrow: 1, flexBasis: '50%' }}>
					<h3>Community campaigns</h3>
					<VetCampaignsInAreaData
						vet_id={vet_id}
						data={data.filter(({ campaign_target, status }) => campaign_target !== 'public' && status === 'active')}
						loading={loading}
						setLoading={setLoading}
						title={"Active campaigns"}
						active
						community
						optOut={optoutCommunity}
					/>
					<VetCampaignsInAreaData
						vet_id={vet_id}
						data={data.filter(({ campaign_target, status }) => campaign_target !== 'public' && status === 'upcoming')}
						loading={loading}
						setLoading={setLoading}
						title={"Upcoming campaigns"}
						upcoming
						community
						optOut={optoutCommunity}
					/>
					<VetCampaignsInAreaData
						vet_id={vet_id}
						data={data.filter(({ campaign_target, status }) => campaign_target !== 'public' && status === 'past')}
						loading={loading}
						setLoading={setLoading}
						title={"Past campaigns"}
						past
						community
						optOut={optoutCommunity}
					/>
				</div>
			
		</div>
	)

}
